// src/data/platformIcons.js

import netflix from '../images/streaming/netflix.webp';
import netflixAd from '../images/streaming/netflixad.webp';
import amazonPrimeVideo from '../images/streaming/prime.webp';
import amazonPrimeVideoAds from '../images/streaming/primeads.webp';
import disneyPlus from '../images/streaming/disney.webp';
import canalPlus from '../images/streaming/canal.webp';
import stan from '../images/streaming/stan.webp';
import foxtelNow from '../images/streaming/foxtelnow.webp';
import binge from '../images/streaming/binge.webp';
import sunNxt from '../images/streaming/sunnxt.webp';
import beamafilm from '../images/streaming/beama.webp';
import paramountPlus from '../images/streaming/paramount.webp';
import looke from '../images/streaming/looke.webp';
import max from '../images/streaming/max.webp';
import globoplay from '../images/streaming/globo.webp'; // Assuming Globoplay icon is not provided, using generic icon
import telecineAmazonChannel from '../images/streaming/primeads.webp'; // Assuming Telecine Channel icon is similar to Amazon Prime Video with Ads
import criterionChannel from '../images/streaming/criterion.webp';
import amc from '../images/streaming/amc.webp';
import crave from '../images/streaming/crave.webp'; // Assuming Crave icon is not provided, using generic icon
import magentaTV from '../images/streaming/magenta.webp'; // Assuming MagentaTV icon is not provided
import skyGo from '../images/streaming/sky.webp';
import wow from '../images/streaming/WOW.webp'; // Assuming WOW icon is not provided
import joynPlus from '../images/streaming/joyn.webp'; // Assuming Joyn Plus icon is not provided
import filmin from '../images/streaming/filmin.webp';
import movistar from '../images/streaming/movistar.webp';
import movistar999 from '../images/streaming/movistar999.webp';
import acontraPlus from '../images/streaming/acontra.webp';
import flixole from '../images/streaming/flixole.webp'; // Assuming FlixOlé icon is not provided
import molotovTV from '../images/streaming/molotov.webp';
import filmo from '../images/streaming/filmo.webp';
import cineOCS from '../images/streaming/cine+.webp'; // Assuming Cine+ OCS icon is not provided
import arrow from '../images/streaming/arrow.webp';
import nowTV from '../images/streaming/now.webp';
import lionsgatePlay from '../images/streaming/lionsgate.webp'; // Assuming Lionsgate Play icon is not provided
import zee5 from '../images/streaming/zee5.webp'; // Assuming Zee5 icon is not provided
import timvision from '../images/streaming/timvision.webp';
import unext from '../images/streaming/unext.webp';
import hulu from '../images/streaming/hulu.webp';
import wavve from '../images/streaming/wavve.webp';
import watcha from '../images/streaming/watcha.webp';
import filmBox from '../images/streaming/filmbox.webp'; // Assuming FilmBox icon is not provided
import mubi from '../images/streaming/mubi.webp';
import peacockPremiumPlus from '../images/streaming/peacockplus.webp';
import fuboTV from '../images/streaming/fubo.webp';
import peacockPremium from '../images/streaming/peacock.webp';
import tf1 from '../images/streaming/tf1.webp';
import shadowz from '../images/streaming/shadowz.webp';
import flixfling from '../images/streaming/flixfling.webp';
import shudder from '../images/streaming/shudder.webp';
import vimovies from '../images/streaming/vimovies.webp';
import hotstar from '../images/streaming/hotstar.webp';
import jiocinema from '../images/streaming/jiocinema.webp';
import lionsgateapple from '../images/streaming/lionsgateapple.webp';
import lionsgateamazon from '../images/streaming/lionsgateamazon.webp';
import infinity from '../images/streaming/infinity.webp';
import cultpix from '../images/streaming/cultpix.webp';
import mgm from '../images/streaming/mgm.webp';
import paramountApple from '../images/streaming/paramountapple.webp';
import paramountAmazon from '../images/streaming/amazonparamountplus.webp';

const platformIcons = {
  'Netflix': netflix,
  'Netflix basic with Ads': netflixAd,
  'Amazon Prime Video': amazonPrimeVideo,
  'Amazon Prime Video with Ads': amazonPrimeVideoAds,
  'Disney Plus': disneyPlus,
  'Canal+': canalPlus,
  'Stan': stan,
  'Foxtel Now': foxtelNow,
  'BINGE': binge,
  'Sun Nxt': sunNxt,
  'Beamafilm': beamafilm,
  'Paramount Plus': paramountPlus,
  'Paramount Plus Apple TV Channel': paramountApple,
  'Paramount Plus Premium': paramountPlus,
  'Paramount+ Amazon Channel': paramountAmazon,
  'Looke': looke,
  'Max': max,
  'Globoplay': globoplay,
  'Telecine Amazon Channel': telecineAmazonChannel,
  'Looke Amazon Channel': looke,
  'Max Amazon Channel': max,
  'Max UNext Channel': max,
  'MGM Amazon Channel': mgm,
  'AMC+ Amazon Channel': amc,
  'Acontra Plus Amazon Channel': acontraPlus,
  'Shudder Amazon Channel': shudder,
  'Jio Cinema': jiocinema,
  'VI movies and tv': vimovies,
  'Criterion Channel': criterionChannel,
  'AMC+': amc,
  'Crave': crave,
  'MagentaTV': magentaTV,
  'Sky Go': skyGo,
  'WOW': wow,
  'Joyn Plus': joynPlus,
  'Filmin': filmin,
  'Movistar Plus+': movistar,
  'Movistar Plus+ €9.99': movistar999,
  'Acontra Plus': acontraPlus,
  'FlixOlé': flixole,
  'FlixFling': flixfling,
  'Molotov TV': molotovTV,
  'FILMO': filmo,
  'Filmo Amazon Channel': filmo,
  'Cine+ OCS Amazon Channel': cineOCS,
  'Infinity Selection Amazon Channel': infinity,
  'ARROW': arrow,
  'Now TV Cinema': nowTV,
  'Now TV': nowTV,
  'Hotstar': hotstar,
  'Lionsgate Play': lionsgatePlay,
  'Lionsgate Play Apple TV Channel': lionsgateapple,
  'Lionsgate Play Amazon Channel': lionsgateamazon,
  'Zee5': zee5,
  'Timvision': timvision,
  'U-NEXT': unext,
  'Hulu': hulu,
  'Cultpix': cultpix,
  'wavve': wavve,
  'Watcha': watcha,
  'FilmBox+': filmBox,
  'MUBI': mubi,
  'Peacock Premium Plus': peacockPremiumPlus,
  'fuboTV': fuboTV,
  'TF1+': tf1,
  'Shadowz': shadowz,
  'Peacock Premium': peacockPremium

};

export default platformIcons;
